<template>
  <v-toolbar
    id="core-toolbar"
    app
    flat
    prominent>
    <div class="v-toolbar-title">
      <v-toolbar-title class="font-weight-regular">
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          icon
          @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer/>
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2>
        <!--        <v-text-field-->
        <!--          v-if="responsiveInput"-->
        <!--          class="mr-4 mt-2 purple-input"-->
        <!--          label="Search..."-->
        <!--          hide-details-->
        <!--          color="purple"-->
        <!--        />-->
        <router-link
          v-ripple
          class="toolbar-items"
          to="/dashboard">
          <v-icon color>mdi-home</v-icon>
        </router-link>
        <v-menu
          bottom
          left
          content-class
          offset-y
          transition="slide-y-transition">

          <v-badge
            slot="activator"
            color="error"
            overlap>
            <template
              v-if="unreadNotification > 0"
              slot="badge">{{ unreadNotification }}
            </template>
            <v-icon color>mdi-bell</v-icon>
          </v-badge>

          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="(val, idx) in notifications"
                :key="val.id"
                class="notify">
                <router-link
                  :class="routerClass(val)"
                  :to="routeLinkTo(val)"
                  @click.native="markAsRead(val)"
                >
                  <v-list-tile-title
                    v-text="val.title"/>
                </router-link>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <router-link
          v-ripple
          class="toolbar-items"
          to="/dashboard/user-profile">
          <v-icon color>mdi-account</v-icon>
        </router-link>
        <v-icon
          class="toolbar-items"
          color
          @click="logout">mdi-logout
        </v-icon>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
  data: () => ({
    // notifications: [
    //   'Mike, Thanos is coming',
    //   '5 new avengers joined the team',
    //   "You're now friends with Capt",
    //   'Another Notification',
    //   'Another One - Dj Khalid voice'
    // ],
    notifications: [],
    unreadNotification: 0,
    username: localStorage.getItem('username'),
    title: 'Dashboard',
    responsive: false,
    responsiveInput: false
  }),

  computed: {
    ...mapGetters(['authorized', 'getNotifications'])
    // unreadNotifyLength () {
    // console.log('computed prop')
    // return this.notifications.filter(e => {
    //   const found = e.to.find(v => v.isRead === false || v.isRead === 'false') // return undefined if not found
    //   return found
    // }).length
    // }
  },

  watch: {
    // $route (val) {
    //   this.title = val.meta.name
    // }
  },
    created () {
      this.title = this.$route.meta.name
      this.getLatestNotifications()
    },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    routerClass (val) {
      let u = this.username
      const data = val.to.find(v => v.username === u && (v.isRead === true || v.isRead === 'true')) // return undefined if not found
      if (data && data.isRead) {
        return 'notify-router-read'
      } else {
        return 'notify-router-unread'
      }
    },
    markAsRead (val) {
      console.log('mark read')
      this.getLatestNotifications(val.id)
    },
    routeLinkTo (val) {
      return `/dashboard/visit?nid=${val.id}&tab=` + (val.type === 'SALES' ? '0' : '1')
    },
    async getLatestNotifications (idnotify) {
      this.notifications = await this.$store.dispatch('syncNotification', idnotify)
      let un = this.username
      if (this.notifications || this.notifications.length > 0) {
        this.unreadNotification = this.notifications.filter(e => {
          const found = e.to.find(v => v.username === un && v.isRead === false) // return undefined if not found
          return found
        }).length
      }
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/')
      })
    }
  }
}
</script>

<style>
	#core-toolbar a {
		text-decoration: none;
  }

  #core-toolbar {
    background-color: #eeeeee;
  }

  .notify:hover {
    background: lightgrey;
  }

  .notify:active {
    background: antiquewhite;
  }

  .notify-router-read {
    color: black
  }

  .notify-router-unread {
    color: green
  }
</style>
